import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Collapse } from "react-collapse";

import { ButtonPrimary, ButtonWrapper } from "components/base/BaseButton";
import { PAYMENT_REQUEST_LIST_API } from "const/apiMethods";
import { checkPermissionsFor } from "store/storeHelpers";
import { withTranslation } from "hoc/WithTranslation";
import { Spacer } from "components/base/Spacer";
import m from "definedMessages";
import PaymentsRequestTable from "./PaymentsRequestTable";
import ModalCancelPaymentRequest from "../ModalCancelPaymentRequest/ModalCancelPaymentReques";
import PaymentsSectionHeader from "components/Payments/PaymentsSectionHeader";


const PaymentsRequestSection = ({
    service,
    paymentRequestItems,
    paymentRequestLoading,
    rejectPaymentRequest,
    getPaymentRequestList,
    openModalRequestPayment,
    currencyName,
    setReadyForPayment,
    permissions,
    updateAccount,

    formatMessage
}) => {
    const [showTable, setShowTable] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [showModalCancelPaymentRequest, setShowModalCancelPaymentRequest] = useState(false);

    useEffect(() => {
        if (!checkPermissionsFor(PAYMENT_REQUEST_LIST_API)) {
            return;
        }

        getPaymentRequestList();
    }, [getPaymentRequestList, permissions]);

    const toggleTable = useCallback(() => {
        setShowTable(prev => !prev);
    }, []);

    const openCancelModal = useCallback(request => {
        setSelectedRequest(request);
        setShowModalCancelPaymentRequest(true);
    }, []);

    const closeCancelModal = useCallback(() => {
        setShowModalCancelPaymentRequest(false);
        setSelectedRequest(null);
    }, []);

    const changeReadyForPayment = useCallback((amount) => {
        setReadyForPayment(prev => +prev + amount);
    }, [setReadyForPayment]);

    return (
        <>
            <PaymentsSectionHeader
                title={formatMessage(m.paymentRequest)}
                show={showTable}
                callback={toggleTable}
            />

            <Collapse isOpened={showTable}>
                <div>
                    <Spacer />

                    <ButtonWrapper justify={"end"}>
                        <ButtonPrimary componentClass={Link} to="/payment-details">
                            {formatMessage(m.managePaymentDetails)}
                        </ButtonPrimary>

                        <ButtonPrimary onClick={openModalRequestPayment}>
                            {formatMessage(m.requestPayment)}
                        </ButtonPrimary>
                    </ButtonWrapper>

                    <Spacer />

                    <PaymentsRequestTable
                        data={paymentRequestItems}
                        loading={paymentRequestLoading}
                        handleCancelPaymentRequest={openCancelModal}
                        currencyName={currencyName}
                    />
                </div>
            </Collapse>

            <ModalCancelPaymentRequest
                show={showModalCancelPaymentRequest}
                onSuccess={changeReadyForPayment}
                onClose={closeCancelModal}
                service={service}
                selectedRequest={selectedRequest}
                rejectPaymentRequest={rejectPaymentRequest}
                getPaymentRequestList={getPaymentRequestList}
                updateAccount={updateAccount}
            />
        </>
    );
};

export default withTranslation(PaymentsRequestSection);
